import { Typography } from "antd"

const { Text } = Typography

type Props = {
  name: string
}

const TruncatedName = ({ name }: Props) => {
  return <Text>
  {
    name.length > 80
      ? <>{name.substring(0, 80)}&hellip;</>
      : name
  }
</Text>
}

export default TruncatedName
